import React from "react";
import { IconButton, useLocalStorage } from "@sscs/ui";
import { OneColumnLayoutIcon, TwoColumnLayoutIcon } from "@sscs/ui/icons";
import { getClassName } from "@sscs/utils";
import styles from "./expandedRowDetails.module.scss";
export const LAYOUT_STORAGE_KEY = "expanded-row-details:layout";
const useLayout = () => {
    const [stored, setStored] = useLocalStorage(LAYOUT_STORAGE_KEY);
    return [stored === "one" ? "one" : "two", setStored];
};
const Aside = ({ children }) => {
    const [layout, setLayout] = useLayout();
    return (React.createElement("div", { className: styles.aside },
        React.createElement("div", { className: styles.strip },
            React.createElement("span", { className: styles.label }, "Change layout"),
            React.createElement("div", { className: styles.toggle, role: "group", "aria-label": "Change layout" },
                React.createElement(IconButton, { size: "small", tooltipTitle: "Two columns", "aria-label": "Two columns", "aria-pressed": layout === "two", className: styles["toggle-button"], onClick: () => setLayout("two") },
                    React.createElement(TwoColumnLayoutIcon, { size: "xs" })),
                React.createElement(IconButton, { size: "small", tooltipTitle: "One column", "aria-label": "One column", "aria-pressed": layout === "one", className: styles["toggle-button"], onClick: () => setLayout("one") },
                    React.createElement(OneColumnLayoutIcon, { size: "xs" })))),
        children));
};
const Main = ({ children }) => (React.createElement("div", { className: styles.main }, children));
const FullWidth = ({ children }) => (React.createElement("div", { className: styles["full-width"] }, children));
const ExpandedRowDetails = ({ id, className, children, }) => {
    const [layout] = useLayout();
    return (React.createElement("div", { id: id, className: getClassName(styles.root, className) },
        React.createElement("div", { className: getClassName(styles.grid, {
                [styles["grid-one"]]: layout === "one",
            }) }, children)));
};
export default Object.assign(ExpandedRowDetails, { Aside, Main, FullWidth });
//# sourceMappingURL=ExpandedRowDetails.js.map